import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex-1 flex items-center justify-start" }
const _hoisted_3 = { class: "flex-1 flex items-center justify-end" }
const _hoisted_4 = { class: "mt-6 flow-root" }
const _hoisted_5 = { class: "divide-y divide-gray-500/10" }
const _hoisted_6 = { class: "space-y-2 py-6" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "py-6" }

import type { MobileMenuProps } from "./MobileMenuProps";
import DialogMenu from "@/views/blocks/common/DialogMenu.vue";
import OpenCloseIcon from "@/views/blocks/common/OpenCloseIcon.vue";
import EditableElement from "@/views/page/EditableElement.vue";
import ButtonComponent from "@/views/blocks/navigation/shared/button/ButtonComponent.vue";
import LogoComponent from "@/views/blocks/navigation/shared/logo/LogoComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileMenuCentered',
  props: {
    button: {},
    callToActionButton: {},
    isOpen: { type: Boolean },
    items: {},
    logo: {},
    styleValues: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleClose = () => {
    emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogMenu, {
    "is-open": _ctx.isOpen,
    "on-close": handleClose,
    position: "right",
    "max-width": "20rem"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "fixed inset-y-0 left-0 z-50 w-full overflow-y-auto p-4 lg:px-6",
        style: _normalizeStyle({
                backgroundColor: _ctx.styleValues.background,
                '--text-color': _ctx.styleValues.text,
            })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              onClick: handleClose
            }, [
              _createVNode(OpenCloseIcon, { "is-open": true })
            ])
          ]),
          _createVNode(LogoComponent, _normalizeProps(_guardReactiveProps(_ctx.logo.data)), null, 16),
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.callToActionButton.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonComponent, _mergeProps(_ctx.callToActionButton.data, {
                      "background-color": _ctx.styleValues.brand,
                      "text-color": _ctx.styleValues.text
                    }), null, 16, ["background-color", "text-color"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.data.items, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: item.id,
                  href: item.href,
                  class: "block link-item py-2 text-base"
                }, _toDisplayString(item.label), 9, _hoisted_7))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (!_ctx.button.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(ButtonComponent, _mergeProps(_ctx.button.data, {
                        "background-color": _ctx.styleValues.background,
                        "text-color": _ctx.styleValues.text
                      }), null, 16, ["background-color", "text-color"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})